import { Theme, ThemeManager } from '@pmi.web/react-theme';
import { RequireAuth } from '@shared/auth';
import { createBrowserRouter, Outlet, RouterProvider } from 'react-router-dom';

import ClarityManager from '@/components/clarity/ClarityManager';
import { UIBlocker } from '@/components/common';
import { ErrorHandler } from '@/components/common/errors/ErrorHandler';
import { DebugDrawer } from '@/components/pages/dev-only/DebugDrawer';
import { PaymentResultGeneric } from '@/components/pages/status-pages/PaymentResultGeneric';
import { ServiceBootstrapper } from '@/components/ServiceBootstrapper';
import { WrapperProviders } from '@/components/wrappers';
import { SignInCallbackPage } from '@/components/wrappers/SignInCallbackPage';
import { AppToastContainer } from '@/libs/toasts';
import { isProdBuild } from '@/utils/env';

import { ManageApp } from './ManageApp';
import { PaymentIntentApp } from './PaymentIntentApp';

const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <RequireAuth>
        {!isProdBuild && <DebugDrawer />}
        <ThemeManager defaultTheme={Theme.PM} />
        <Outlet />
      </RequireAuth>
    ),
    children: [
      {
        index: true,
        element: (
          <ServiceBootstrapper bootstrapMode="payment-intent">
            <ClarityManager />
            <WrapperProviders>
              <PaymentIntentApp />
              <AppToastContainer />
              <UIBlocker />
            </WrapperProviders>
          </ServiceBootstrapper>
        ),
      },
      {
        path: 'manage',
        element: (
          <ServiceBootstrapper bootstrapMode="payment-manage">
            <ClarityManager />
            <WrapperProviders>
              <ManageApp />
              <AppToastContainer />
              <UIBlocker />
            </WrapperProviders>
          </ServiceBootstrapper>
        ),
      },
      {
        path: 'paymentresult',
        element: <PaymentResultGeneric />,
      },
    ],
  },
  {
    path: '/authcallback',
    element: <SignInCallbackPage />,
  },
  {
    path: '*',
    element: <ErrorHandler err={new Error('Page not found')} />,
  },
]);

export function App() {
  return <RouterProvider router={router} />;
}
